// Spanish translation

const es = {
  "app.webcheckin.no_booking": "No. Reserva",
  "app.webcheckin.customer": "Cliente",
  "app.webcheckin.channel": "Canal",
  "app.webcheckin.reservation_detail": "Tu Reserva",
  "app.webcheckin.experiences": "Experiencias",
  "app.webcheckin.experiences.melhous": "App Exclusiva Para Clientes",
  "app.webcheckin.meal_plan": "Regimen de comida",
  "app.webcheckin.nights_quantity": "{nights} noches",
  "app.webcheckin.reserved rooms": "Habitaciones Reservadas",
  "app.webcheckin.intro_info":
    "Ahora podrás hacer check-in de forma ágil y descomplicada.",
  "app.webcheckin.view_guest": "Ver huéspedes registrados",
  "app.webcheckin.max_accommodation": "Hasta {max} huéspedes",
  "app.webcheckin.register_guest": "Registrar huéspedes",
  "app.webcheckin.hello": "¡Hola, ",
  "app.webcheckin.title": "Web Check-in",
  "app.webcheckin.name_guest": "Nombre",
  "app.webcheckin.type_guest": "Tipo",
  "app.webcheckin.melhous_btn": "VER MELHOUS",
  "staff.supply.no_signature": "Agrega tu firma",
  "app.webcheckin.contact": "Contacto",
  "app.webcheckin.arrive.date": "Llegada",
  "app.webcheckin.departure.date": "Partida",
  "app.webcheckin.melhos.description":
    "Con Melhous ahora tendrás acceso a todos nuestros servicios y podrás disfrutar las experiencias exclusivas solo para clientes. Descubre todo lo que tenemos para ofrecer  ",
  "app.webcheckin.melhos.description_tra":
    "Para disfrutar de una mejor experiencia en nuestro hotel",
  "app.webcheckin.melhos.use_app":
    "¡Puedes usar nuestra App!, Fresco que no necesitas descargarla 😎",
  "app.webcheckin.melhos.click": "aqui.",
  "app.webcheckin.experiences.description":
    "Disfruta de las mejores experiencias que hemos preparado para ti.",
  "app.webcheckin.msg_ok": "Registro completado exitosamente.",
  "app.webcheckin.msg_missing": "Faltan campos obligatorios",
  "app.webcheckin.extra_fields": "Solicitudes especiales",
  "app.webcheckin.placeholder.description": "Escribe la descripción",
  "app.webcheckin.main_guest_description":
    "Este registro será del huésped principal de la reserva.",
};

export default es;
